export const TOGGLE_FEEDBACKFORM_MODAL = 'TOGGLE_FEEDBACKFORM_MODAL';

export const toggleFeedbackForm = () => async (dispatch) => {
  dispatch({
    type: TOGGLE_FEEDBACKFORM_MODAL,
  });
};
